/**
 * @props heading: (string) - header text of the toast 
 * @props message: (string) - message on the toast
 * @props isOpen: (boolean) - default state of the toast
 * @props variant: (string) - As per variant, different styles are applied to the toaster. Use TOASTER_VARIANT constant to use different variants.
*/

import React, { useEffect, useState } from 'react'
import Label from '../label/Label'
import HoverContainer from '../hovercontainer/HoverContainer'
import Icons from '../icons/Icons'
import { VEC_ICON_NAME } from '../icons/constants'
import styles from "./TxToast.styles"
import { TOASTER_VARIANT } from './constants'
import General from '../../../libs/utility/General'

export default function TxToast({
    heading = "",
    message = "",
    isOpen = true,
    variant = "danger",
    autoCloseTime = 6000,
    onCloseCb = () => { }
}) {

    const [show, setShow] = useState(isOpen);

    useEffect(() => {
        const timer = setTimeout(() => {
            setShow(false);
            onCloseCb();
        }, autoCloseTime);

        return () => clearTimeout(timer);
    }, []);

    return (
        <>
            {show && <div style={{ ...styles.toaster, ...getToastVariantStyles(variant) }}>

                <div style={styles.toastHeaderContainer}>
                    <Label customStyles={styles.toastHeader} >{heading}</Label>

                    <HoverContainer onClick={onCloseCb} >
                        <Icons familyName='vec' iconName={VEC_ICON_NAME.CLOSE} style={styles.closeIcon} />
                    </HoverContainer>
                </div>

                {message &&
                    <div style={styles.toastBodyContainer}>
                        <div style={styles.toastMessage}>
                            <p style={styles.innerHtmlContent} dangerouslySetInnerHTML={{ __html: General.sanitizeContent(message) }} />
                        </div>
                    </div>
                }

            </div>}
        </>
    )
}

const getToastVariantStyles = (variant) => {
    switch (variant) {
        case TOASTER_VARIANT.LIGHT: default: return styles.buttonPrimary;
        case TOASTER_VARIANT.SUCCESS: return styles.successVariant;
        case TOASTER_VARIANT.DANGER: return styles.dangerVariant;
        case TOASTER_VARIANT.WARNING: return styles.warningVariant;
    }
}